export default __webpack_public_path__ + "static/media/image010.797431ab.png";